"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _icons = require("../../../../assets/icons");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isOpen", "onClose", "children", "dataTestId", "variantProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ModalHeaderContent = _ref => {
  var {
    title,
    priceText,
    prefix
  } = _ref;
  return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, styles.header), {}, {
    children: [(0, _jsxRuntime.jsxs)(_react.Box, {
      children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({}, styles.title), {}, {
        children: title
      })), priceText && (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, styles.priceText), {}, {
        children: priceText
      }))]
    }), (0, _jsxRuntime.jsx)(_react.ModalCloseButton, _objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalCloseButton")
    }, styles.modalCloseButton), {}, {
      children: (0, _jsxRuntime.jsx)(_react.Icon, _objectSpread({
        as: _icons.Dismiss
      }, styles.closeIcon))
    }))]
  }));
};
var RoomUpgradeModal = _ref2 => {
  var {
      isOpen,
      onClose,
      children,
      dataTestId = '',
      variantProps
    } = _ref2,
    modalProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  return (0, _jsxRuntime.jsxs)(_react.Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    scrollBehavior: "inside",
    isOpen: isOpen,
    onClose: onClose,
    closeOnOverlayClick: false,
    isCentered: true,
    motionPreset: "slideInBottom",
    size: "lg"
  }, modalProps), {}, {
    children: [(0, _jsxRuntime.jsx)(_react.ModalOverlay, {}), (0, _jsxRuntime.jsxs)(_react.ModalContent, {
      "data-testid": "".concat(prefix, "ModalContent"),
      children: [(0, _jsxRuntime.jsx)(_react.ModalHeader, {
        p: "0",
        "data-testid": "".concat(prefix, "ModalHeader"),
        children: variantProps && variantProps.title && variantProps.priceText && (0, _jsxRuntime.jsx)(ModalHeaderContent, {
          title: variantProps.title,
          priceText: variantProps.priceText,
          prefix: prefix
        })
      }), (0, _jsxRuntime.jsx)(_react.ModalBody, _objectSpread(_objectSpread({
        p: "0",
        "data-testid": "".concat(prefix, "ModalBody")
      }, contentStyles), {}, {
        children: children
      }))]
    })]
  }));
};
var styles = {
  modalCloseButton: {
    h: 'var(--chakra-space-xl)',
    w: 'var(--chakra-space-xl)',
    ml: 'auto',
    position: 'static',
    _focus: {
      boxShadow: 'none'
    },
    _hover: {
      bgColor: 'transparent'
    },
    _active: {
      bgColor: 'transparent'
    }
  },
  header: {
    p: 5,
    justify: 'space-between',
    align: 'baseline'
  },
  title: {
    as: 'h2',
    size: 'md',
    color: '#511E62',
    fontWeight: '900'
  },
  priceText: {
    fontSize: 'sm',
    color: '#333333',
    fontWeight: '600',
    mt: '5px'
  },
  closeIcon: {
    transform: 'scale(1.1)',
    stroke: '#511E62'
  }
};
var contentStyles = {
  sx: {
    ul: {
      ml: 'md'
    }
  }
};
var _default = exports.default = RoomUpgradeModal;